var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":[
    {
      text: 'Teste SAMP',
      value: 'teste_samp'
    },
    {
      text: 'Erros Críticos',
      value: 'erros_criticos',
      align: 'center'
    },
    {
      text: 'Não Críticos',
      value: 'erros_nao_criticos',
      align: 'center'
    },
    {
      text: 'Exceções',
      value: 'excecoes',
      align: 'center'
    },
    {
      text: 'Análises Futuras',
      value: 'analises_futuras',
      align: 'center'
    }
  ],"items":_vm.errosSamp,"loading":_vm.loading,"hide-default-header":_vm.loading,"hide-default-footer":"","disable-pagination":""},scopedSlots:_vm._u([{key:"item.teste_samp",fn:function(ref){
  var item = ref.item;
return [_c('span',{style:({ color: _vm.getCorLinha(item) })},[_vm._v(_vm._s(item.teste_samp))])]}},{key:"item.erros_criticos",fn:function(ref){
  var item = ref.item;
return [_c('span',{style:({ color: _vm.getCorLinha(item) })},[_vm._v(_vm._s(_vm._f("parseNumberToIntegerBR")(item.erros_criticos)))])]}},{key:"item.erros_nao_criticos",fn:function(ref){
  var item = ref.item;
return [_c('span',{style:({ color: _vm.getCorLinha(item) })},[_vm._v(_vm._s(_vm._f("parseNumberToIntegerBR")(item.erros_nao_criticos)))])]}},{key:"item.excecoes",fn:function(ref){
  var item = ref.item;
return [_c('span',{style:({ color: _vm.getCorLinha(item) })},[_vm._v(_vm._s(_vm._f("parseNumberToIntegerBR")(item.excecoes)))])]}},{key:"item.analises_futuras",fn:function(ref){
  var item = ref.item;
return [_c('span',{style:({ color: _vm.getCorLinha(item) })},[_vm._v(_vm._s(_vm._f("parseNumberToIntegerBR")(item.analises_futuras)))])]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }